document.addEventListener("DOMContentLoaded", function () {
  const sections = document.querySelectorAll(".discovery-random-grid");
  if (!sections.length) return;

  sections.forEach(function (section) {
    const collectionHandle = section.dataset.collectionHandle;
    const sectionId = section.dataset.sectionId;

    const grid = document.getElementById("DiscoveryGrid-" + sectionId);
    const button = document.getElementById("DiscoveryMore-" + sectionId);

    if (!grid || !button) return;

    if (!collectionHandle) {
      console.warn(
        "Discovery grid: missing collection handle. Did you set the collection in index.json?"
      );
      button.style.display = "none";
      return;
    }

    let page = 1;
    let buffer = [];

    function shuffle(array) {
      // simple shuffle is fine for discovery
      return array.sort(() => Math.random() - 0.5);
    }

    async function fetchProducts() {
      const url =
        "/collections/" +
        collectionHandle +
        "/products.json?limit=250&page=" +
        page;

      const response = await fetch(url, { credentials: "same-origin" });

      if (!response.ok) {
        console.error("Discovery grid: fetch failed", response.status, url);
        return [];
      }

      const data = await response.json();
      page++;

      const products = data && data.products ? data.products : [];
      return shuffle(products);
    }

    async function fillBuffer(minBufferSize) {
      // Keep at least minBufferSize products buffered
      while (buffer.length < minBufferSize) {
        const products = await fetchProducts();
        if (!products.length) break;
        buffer = buffer.concat(products);
      }
    }

    function renderProducts(targetCount) {
      let html = "";
      let added = 0;

      // Keep pulling until we actually ADD targetCount valid products,
      // or we run out of buffer.
      while (added < targetCount && buffer.length > 0) {
        const product = buffer.shift();
        if (!product || !product.handle) continue;

        // Skip sold-out products
        if (product.available === false) continue;

        const image =
          product.images && product.images[0] && product.images[0].src
            ? product.images[0].src
            : "";

        html += `
          <a class="discovery-card is-new" href="/products/${product.handle}">
            <div class="discovery-card__media">
              ${image ? `<img src="${image}" loading="lazy" alt="">` : ""}
            </div>
            <div class="discovery-card__meta">
              <div class="discovery-card__title">${product.title}</div>
            </div>
          </a>
        `;

        added += 1;
      }

      if (html) {
        grid.insertAdjacentHTML("beforeend", html);
        requestAnimationFrame(() => {
            const newCards = grid.querySelectorAll(".discovery-card.is-new");
              newCards.forEach((el) => el.classList.remove("is-new"));
});
      } else {
        console.warn(
          "Discovery grid: no products rendered. Collection may be empty, unavailable, or all items are sold out."
        );
      }
    }

    async function initialLoad() {
      button.disabled = true;
      await fillBuffer(24); // buffer a bit more than initial render
      renderProducts(12);   // initial load count (good for 6-column mosaic)
      button.disabled = false;
    }

    button.addEventListener("click", async function () {
      button.disabled = true;
      await fillBuffer(24); // keep a small buffer so clicks feel fast
      renderProducts(12);   // add per click
      button.disabled = false;
    });

    initialLoad();
  });
});